/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { setMaxHeightByQuery } from "src/libs/utilities"
import { ALIGN, ICard, ImageContent, IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import "../../../../assets/css/cards.scss"
import { ICardsProps } from "../Cards"
import Card from "./Card"
import { Gallery } from "src/libs/useful"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { NAVIGATION_POSITION_TYPE } from "src/libs/useful/gallery/Gallery"
import DataContentEditor from "../../landing-edit/editors/data-content-editor"
import { ImagePrimitive } from "../../primitive"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
const CardsCarousel = ({data, ...props}: ICardsProps): JSX.Element => {
    const thumbRef              = useRef<HTMLDivElement>(null)
    const composition           = useComposition(props.section)
    const sizes                 = useLandingSize()    
    const currentDimensionEdit  = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    const sizeWidth             = Math.min( sizes.width, currentDimensionEdit )

    const [marginLeft]          = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)    || !data.horizontal_align ? "auto" : "0")
    const [marginRight]         = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginTop]           = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align)      || !data.vertical_align   ? "auto" : "0")
    const [marginBottom]        = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align)    || !data.vertical_align   ? "auto" : "0")
    const [width]               = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]            = useState<string>(getCssDemention( data.height, "fit-content" ))
    const [thumbnailSize, setThumbnailSize] = useState<IScreenPosition>({ width: "100%", height: "100%" })
    const alignFields = () => {
        if(!data.vertical_align || data.vertical_align === ALIGN.FULL ) {
            data.card_fields.forEach((field, i) => {
                setMaxHeightByQuery( `.landing-cards-${data.id} [data-card-field-id="${i}"]` );
                setMaxHeightByQuery( `.landing-cards-${data.id} [data-card-field-id="${i}"] .speech-bubble-content`);
            })
        }
    }
    useEffect(() => {
        addCSSClass(
            `landing-cards-${props.section.id}`,
            `.landing-cards-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        )        
        if(thumbRef.current) {
            const thumb = thumbRef.current
            setThumbnailSize({
                width:  thumb.clientWidth,
                height: thumb.clientHeight,
                aspect: thumb.clientWidth / thumb.clientHeight
            })
        }
        const timer = setTimeout(() => {
            alignFields()
        }, 100)
        
        return () => {
            clearTimeout( timer )
            removeCSSClass(`landing-card-${data.id}`)
        }
    },[])
       
    useEffect(()=> {
        const timer = setTimeout(() => {
            alignFields()
        }, 100)
        return () => {
            clearTimeout( timer )
        } 
    }, [ composition ])

    const cards: JSX.Element[] = Array.isArray(data.cards) 
        ?
        data.cards.map((card: ICard, i: number) =>  { 
            return <Card
                key={ card.id }
                data={ { ...card, i:i } }
                width={ 100 }
                contentData={ data }
                section={ props.section }
            />
        })
        :
        [] 
    
    
    // console.log( data )
    
    const getLandingWidth = (): number => {
        const scrollWidth = 8 
        if( sizeWidth >= WINDOW_WIDTH.PANEL - scrollWidth ) {
            return data.columns || 1
        }
        else if( sizeWidth >= WINDOW_WIDTH.LARGE - scrollWidth ) {
            return data.columns || 1
        }
        else if( sizeWidth >= WINDOW_WIDTH.SCREEN - scrollWidth ) {
            return 3
        }
        else if( sizeWidth >= WINDOW_WIDTH.TABLET - scrollWidth ) {
            return 2
        }
        else if( sizeWidth >= WINDOW_WIDTH.MOBILE - scrollWidth ) {
            return 2
        }
        else {
            return 1
        }
    }
    return <div 
        className={`pe-cards-container landing-content-container`}  
        data-type={data.type} 
        data-content-id={data.id}
    > 
        <div 
            className="landing-cards-container" 
            style={{ 
                gridTemplateColumns: data.isRightThumbnail 
                    ? 
                    `${100 - 100* (data.proportia || .5)}% ${100 * (data.proportia || .5) }%`
                    :
                    `${100* (data.proportia || .5)}% ${100 - 100 * (data.proportia || .5) }%`
            }}
        >    
            {
                data.thumbnail && 
                    <div className={ `cards-thumbnail cards-thumbnail-${ data.id } ${ data.isRightThumbnail ? "is-right" : "" }`} ref={ thumbRef }>
                        {
                            thumbnailSize.width !== "100%" && 
                                <>
                                    <ImagePrimitive 
                                        section={props.section}
                                        field="thumbnail"
                                        primitive={{
                                            ...data.thumbnail, 
                                            id: `thumbnail-${data.id}`,
                                            position: { ...thumbnailSize },
                                            data: { ...(data.thumbnail ? data.thumbnail.data : {}), src_type: "div" } 
                                        } as ImageContent }
                                    />
                                </>
                        } 
                    </div>
            }    
            <div className={`landing-cards landing-cards-${data.id} ${ data.className || "" } `} >
                <Gallery 
                    items={ cards } 
                    itemWidth="100%"                
                    itemHeight={ data.height } 
                    pagination={ data.is_nagination }
                    navigation
                    navigationType={ data.carousel_nav}
                    navigationThemeType={ data.carousel_nav_theme }
                    navigationSizeType={ data.carousel_nav_size }
                    navigationDesignType={ data.carousel_nav_type }
                    navigationPositionType={ data.carousel_nav_position || NAVIGATION_POSITION_TYPE.TOP_RIGHT} 
                    count={ getLandingWidth() }
                    loop
                    type="element"
                    padding={ data.gap || 0 }
                /> 
            </div>
            <DataContentEditor data={data}  section={props.section} />
        </div>
    </div>
}
export default CardsCarousel